import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Button } from './models/button.model';
import { Field } from './models/field.model';

/**
 * Componente que crea formulario dinamicos
 */
@Component({
    selector: 'app-dynamic-form-builder',
    template: `
    <form [formGroup]="form" class="form-horizontal" *ngIf="form">
      <div class="row">
      <div *ngFor="let field of fields" class="{{col}}">
            <app-field-builder [field]="field" [form]="form" [color]="color"></app-field-builder>
          </div>
      </div>
      <div class="form-row"></div>
      <div class="form-group row" *ngIf="button.visible">
        <div class="col-12 text-center">
          <button type="button" [disabled]="!form.valid"
          class="btn btn-primary btn-lg bg-blue w-100" (click)="save()">{{ button.action }}</button>
          <strong *ngIf="button.message" >{{ button.message }}</strong>
        </div>
      </div>
    </form>
  `,
    standalone: false
})
export class DynamicFormBuilderComponent implements OnInit {
  /**
   * Indica si se debe enviar la info
   */
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSubmit = new EventEmitter();
  /**
   * Campos del formulario
   */
  @Input() fields: Field[] = [];
  /**
   * Informacion del boton de guardado
   */
  @Input() button!: Button;
  /**
   * Indica como se debe construir las columnas del form
   */
  @Input() col = '';
  /**
   * Indica el color de los labels de los campos
   */
  @Input() color = '';
  /**
   * Formulario
   */
  form!: UntypedFormGroup;

  /**
   * Constructor
   */
  constructor(
  ) { }

  /**
   * Inicializa el formulario
   */
  ngOnInit(): void {
    if (!this.col) {
      this.col = 'col-4';
    }
    const controls: { [key: string]: AbstractControl } = {};
    for (const f of this.fields) {
      const validations: ValidatorFn[] = [];
      if (f.required) {
        validations.push(Validators.required);
      }
      if (f.required && f.type === 'checkbox') {
        validations.push(Validators.requiredTrue);
      }
      if (f.minLength !== undefined) {
        validations.push(Validators.minLength(f.minLength));
      }
      if (f.maxLength !== undefined) {
        validations.push(Validators.maxLength(f.maxLength));
      }
      if (f.max !== undefined) {
        validations.push(Validators.max(+f.max));
      }
      if (f.min !== undefined) {
        validations.push(Validators.min(+f.min));
      }
      if (f.pattern !== undefined) {
        validations.push(Validators.pattern(f.pattern));
      }
      const value = f.value !== undefined ? f.value : f.default;
      const control = new UntypedFormControl(
        {
          value,
          disabled: f.disabled
        },
        validations
      );
      controls[f.name] = control;
    }
    this.form = new UntypedFormGroup(controls);
  }

  /**
   * Valida si el formulario esta correcto
   * de ser asi envia los datos
   *
   */
  save(): void {
    if (this.form.valid) {
      this.onSubmit.emit(this.form.value);
    } else {
    }
  }
}
